'use client';

import React, { useEffect, useRef } from 'react';

export default function TestimonialsSection() {
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (headerRef?.current) observer?.observe(headerRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="testimonials"
      className="py-32 bg-[#0F1C2E]"
      aria-labelledby="testimonials-heading"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div ref={headerRef} className="text-center mb-16 reveal-hidden">
          <p className="text-[#E8DED1]/60 text-sm font-medium tracking-[0.25em] uppercase mb-4">
            Reviews
          </p>
          <h2
            id="testimonials-heading"
            className="font-display text-white text-4xl lg:text-5xl font-medium"
          >
            What Our Customers Say
          </h2>
        </div>

        {/* Placeholder */}
        <div className="border border-white/10 rounded-2xl p-12 text-center">
          <div className="w-14 h-14 rounded-full bg-[#E8DED1]/10 flex items-center justify-center mx-auto mb-6">
            <svg width="24" height="20" viewBox="0 0 18 14" fill="none">
              <path
                d="M0 14V8.4C0 6.133 0.567 4.167 1.7 2.5C2.833 0.833 4.467 0 6.6 0L7.2 1.2C5.8 1.667 4.7 2.467 3.9 3.6C3.1 4.733 2.7 5.933 2.7 7.2H5.4V14H0ZM10.8 14V8.4C10.8 6.133 11.367 4.167 12.5 2.5C13.633 0.833 15.267 0 17.4 0L18 1.2C16.6 1.667 15.5 2.467 14.7 3.6C13.9 4.733 13.5 5.933 13.5 7.2H16.2V14H10.8Z"
                fill="#E8DED1"
                fillOpacity="0.4"
              />
            </svg>
          </div>
          <p className="text-white/60 text-lg leading-relaxed max-w-md mx-auto">
            Customer reviews coming soon.
          </p>
        </div>
      </div>
    </section>
  );
}
